import { ThemeOverrides } from '../charts.model';

export const constrastTheme: ThemeOverrides = {
    colors: ['#7A49DD', '#E8BB41', '#E2933B', '#687DE3', '#FD9BA5', '#2775CA'],
};

export const complementaryTheme: ThemeOverrides = {
    colors: ['#687DE3', '#FD9BA5', '#7A49DD'],
};

export const monochromeTheme: ThemeOverrides = {
    colors: ['#545CF8', '#9297f6', '#BCBFFB'],
};

export const thresholdTheme: ThemeOverrides = {
    colors: ['var(--color-content'],
    gridStyles: {
        strokeWidth: 1,
        strokeDasharray: '4',
    },
};
